module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/przyroda.jpg?b4d86a45";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/przyroda.jpg
// module id = 2431
// module chunks = 0